import styled from 'styled-components';

export const EditableCriterionCell = styled.input`
  text-align: center;
  background-color: #1b232e;
  width: 125px;
  height: 25px;
  cursor: text;
  margin: 0.25em 0.5em;
  color: #fff;
  padding: 1px 0px;
  border-style: none;
  border-radius: 5px;
`

export const EditableCriterionCellSelect = styled.select`
  width: 90px;
  height: 28px;
  padding: 0px 10px;
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  background: #171e3a;
  border: .5px solid #31373e;
  border-radius: .25rem;
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
`

